export default {
  // 创建会话
  createSession: '/api/v1/view/session/createSession',
  // 保存会话
  saveSession: '/api/v1/session/saveSession',
  // 获取历史会话
  getSessionHistory: '/api/v1/session/getSessionHistory',
  // 编辑
  edit: '/api/v1/session/edit',
  // 删除
  delete: '/api/v1/session/delete',
  // 该会话是否处于连接中
  userIsService: '/api/session/userIsService',
}
